<template>
  <div>
    <div class="container-carousel">
      <slider :photosNumber="photosNumber" :labelImageToShow="labelImageToShow"></slider>
    </div>
    <h1 class="no-margin">{{ $t("label.master.namSan") }}</h1>
    <h2 class="no-margin">{{ $t("label.master.namSan3") }}</h2>
    <h2 class="no-margin">{{ $t("label.master.namSan2") }}</h2>
    <div class="border-seperator">
      <div class="col-50">
        <div class="block">
          <h2>{{ $t('label.master.titles') }}</h2>
          <p
            class="honors"
            v-for="(n, index) in 14"
            :key="n[index]"
          >{{ $t(`label.master.graduations.titles.${index + 1}`) }}</p>
        </div>
      </div>
      <div class="col-50">
        <div class="block">
          <h2>{{ $t(`label.master.graduations.header`) }}</h2>
          <article>
            <p
              v-for="(n, index) in 5"
              :key="n[index]"
            >{{ $t(`label.master.graduations.${index + 1}`) }}</p>
          </article>
        </div>
      </div>

      <div class="clear"></div>
    </div>
    <h1 class="no-margin">{{ $t("label.championships") }}</h1>
    <div class="border-seperator">
      <div class="col-50">
        <div class="block">
          <h2>{{ $t('label.taekwondo') }}</h2>
          <p v-for="(firstMartialArt, index) in taekwondo" :key="firstMartialArt[index]">
            <img
              :src="require(`@/assets/logos/${firstMartialArt.medal}.png`)"
              alt="{{}}"
              class="medal-list"
            />
            {{ $t(`label.master.championships.taekwondo.${index + 1}`) }}
          </p>
        </div>
      </div>
      <div class="col-50">
        <div class="block">
          <h2>{{ $t(`label.othersMartialsArts`) }}</h2>
          <article>
            <p
              v-for="(n, index) in 3"
              :key="n[index]"
            >{{ $t(`label.master.championships.other.${index + 1}`) }}</p>
          </article>
        </div>
      </div>

      <div class="clear"></div>
    </div>
    <h1 class="no-margin">{{ $t("label.awards") }}</h1>
    <div class="border-seperator">
      <div class="col-50">
        <div class="block">
          <h2>{{ $t('label.master.awardsTitle') }}</h2>
          <p
            class="honors"
            v-for="(n, index) in 3"
            :key="n[index]"
          >{{ $t(`label.master.awards.taekwondo.${index + 1}`) }}</p>
        </div>
      </div>
      <div class="col-50">
        <div class="block">
          <h2>{{ $t(`label.master.awards.header`) }}</h2>
          <article>
            <p
              v-for="(n, index) in 2"
              :key="n[index]"
            >{{ $t(`label.master.awards.other.${index + 1}`) }}</p>
          </article>
        </div>
      </div>

      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
import Slider from "@/components/slider/Slider.vue";
import CONSTANTS from "./constants.js";
export default {
  name: "Master",

  components: {
    Slider
  },

  computed: {
    photosNumber() {
      return 29;
    },
    labelImageToShow() {
      return "master";
    },
    taekwondo() {
      return CONSTANTS.CHAMPIONSHIPS.TAEKWONDO;
    },
    otherMartialArts() {
      return CONSTANTS.CHAMPIONSHIPS.OTHERS;
    }
  }
};
</script>

<style>

.container-carousel {
  padding: 10px 25px;
  padding-bottom: 60px;
}
.medal-list {
  width: 2%;
}

@media (max-width: 833px) {
  .container-carousel {
    padding: 0px 25px;
    padding-bottom: 50px;
  }

  .medal-list {
    width: 5%;
  }
}
</style>
